class PdpUpsellQuantityControls extends HTMLElement {
  constructor() {
    super();
  }

  // Called when the element is inserted into a document.
  connectedCallback() {
    this.section = this;
    this.input = this.section.querySelector(`input[type="number"]`);

    this.section.addEventListener("click", this.sectionEventHandler.bind(this));

    this.section.addEventListener("input", this.inputEventHandler.bind(this));
  }

  // Called when the element is removed from a document.
  disconnectedCallback() {
    this.section.removeEventListener(
      "click",
      this.sectionEventHandler.bind(this)
    );
  }

  /**
   * Gets the current quantity value from the input field.
   * @returns {number} The quantity value.
   */
  getQuantity() {
    return parseInt(this.input.value);
  }

  /**
   * Handles click events within the section, specifically for buttons.
   * @param {Event} event - The click event.
   */
  sectionEventHandler(event) {
    const button = event.target.closest("button");
    if (!button) return;
    const { quantityAction } = button.dataset;
    this.updateInput(this, quantityAction);
  }

  //  Handles input events within the input field.
  inputEventHandler() {
    const value = this.input.value;
    this.dispatchInputValueChangeEvent(value);
  }

  /**
   * Updates the input value based on the specified action.
   * @param {Object} obj - The object containing the input field.
   * @param {string} action - The action to perform (either "plus" or "minus").
   */
  updateInput(obj, action) {
    switch (action) {
      case "plus": {
        let currentValue = parseInt(obj.input.value);
        obj.input.value = currentValue + 1;
        obj.dispatchInputValueChangeEvent(obj.input.value);
        return;
      }
      case "minus": {
        let currentValue = parseInt(obj.input.value);
        if (currentValue === 1) return;
        obj.input.value = currentValue - 1;
        obj.dispatchInputValueChangeEvent(obj.input.value);
        return;
      }
      default:
        break;
    }
  }

  /**
   * Dispatches a custom event indicating a change in quantity value.
   * @param {string} value - The new value of the input field.
   */
  dispatchInputValueChangeEvent(value) {
    this.dispatchEvent(
      new CustomEvent("pdp-upsell-quantity-control-quantity-change", {
        bubbles: true,
        detail: {
          quantity: parseInt(value),
        },
      })
    );
  }

  // Resets the input field value to 1.
  resetValue() {
    this.input.value = 1;
  }
}

customElements.define(
  "pdp-upsell-quantity-controls",
  PdpUpsellQuantityControls
);
